import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { UserDetailsResponse, UserSummaryResponse } from '../../../../interfaces/response/UserResponses';
import { UserDetails } from '../../../models/user/UserDetails';
import { UserSummary } from '../../../models/user/UserSummary';

/**
 * An adapter converts user details HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class UserDetailsAdapter implements Adapter<UserDetails> {

  /**
   * Converts user details HTTP response to {@link UserDetails}.
   * @param item user HTTP response.
   */
  adapt(item: UserDetailsResponse): UserDetails {
    return new UserDetails(
      item.email,
      item.stores,
      item.groups
    );
  }
}

/**
 * An adapter converts user summary HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class UserSummaryAdapter implements Adapter<UserSummary[]> {

  /**
   * Converts user summary HTTP response to {@link UserSummary}.
   * @param items user HTTP response.
   */
  adapt(items: UserSummaryResponse[]): UserSummary[] {
    return items
      .filter(item => !item.email.includes('@satalia.com'))
      .map(item => new UserSummary(item.email));
  }
}
